<div
  class="widget-box"
  *ngIf="item.type === 'counter'"
  [ngClass]="[widgetStyle, sizeClass]"
  [ngStyle]="getWidgetStyles()"
>
  <div class="flex align-items-center justify-content-between">
    <div class="flex flex-column align-items-start justify-content-between">
      <div
        *ngIf="item.titleIcon || item.titleLogo || item.titleIconLabel"
        class="flex align-items-baseline justify-content-start mb-2"
      >
        <i [class]="item.titleIcon"></i>
        <img [src]="item.titleLogo" alt="title icon" height="18" width="auto" />
        <span class="ml-2 text-md font-bold">{{ item.titleIconLabel }}</span>
      </div>
      <span>{{ item.title }}</span>
      <div class="flex align-items-baseline justify-content-start">
        <span class="text-3xl font-bold">{{ item.valueLabel || item.value }}</span>
        <span *ngIf="item.maxValue != null">/{{ item.maxValueLabel || item.maxValue }}</span>
      </div>
    </div>
    <div class="flex align-items-center justify-content-end">
      <p-button
        [icon]="item.icon || ''"
        [severity]="item.buttonSeverity ?? null"
        [outlined]="item.buttonOutlined ?? false"
        [text]="item.buttonText ?? false"
        [styleClass]="getButtonClass()"
        (onClick)="onButtonClick()"
      ></p-button>
    </div>
  </div>
  <div class="flex flex-column align-items-center justify-content-between gap-1">
    <p-progressBar
      *ngIf="item.maxValue != null"
      class="w-full"
      [color]="progressColor"
      [value]="((item.value || 0) / (item.maxValue || 0)) * 100 || 0"
      [style]="{ height: '6px' }"
      [showValue]="false"
    ></p-progressBar>
    <span class="w-full" [ngStyle]="{ color: getDescriptionColor() }">{{ item.description }}</span>
  </div>
</div>

<div
  class="widget-box"
  *ngIf="item.type === 'description'"
  [ngClass]="[widgetStyle, sizeClass]"
  [ngStyle]="getWidgetStyles()"
>
  <div class="flex align-items-center justify-content-between">
    <div class="flex flex-column align-items-start justify-content-between">
      <div
        *ngIf="item.titleIcon || item.titleLogo || item.titleIconLabel"
        class="flex align-items-baseline justify-content-start mb-2"
      >
        <i [class]="item.titleIcon"></i>
        <img [src]="item.titleLogo" alt="title icon" height="18" width="auto" />
        <span class="ml-2 text-md font-bold">{{ item.titleIconLabel }}</span>
      </div>
      <span class="text-xl font-bold mb-2">{{ item.title }}</span>
      <span class="text-sm mb-2">{{ item.description }}</span>
      <div class="flex align-items-center justify-content-end">
        <p-button
          [label]="item.iconButtonLabel || ''"
          [icon]="item.icon || ''"
          size="small"
          [severity]="item.buttonSeverity ?? null"
          [outlined]="item.buttonOutlined ?? false"
          [text]="item.buttonText ?? false"
          [styleClass]="getButtonClass()"
          (onClick)="onButtonClick()"
        ></p-button>
      </div>
    </div>
  </div>
</div>
